import dayjs from 'dayjs';
import RecordRTC from 'recordrtc';
import { webrtcActions as actions } from 'webrtc-client-janus';
import { all } from 'async-saga';
import { takeEvery } from '../tools/async-saga-types';
import { selectRecordCalls } from '../reducers/janusExtra';

let stopRecording: (() => void) | null = null

const recordCalls = takeEvery(actions.callStatusChanged, async (ctx, { focusCallIndex, calls }) => {
  const call = calls[focusCallIndex]
  if (!call) { return }

  if (call.status === 'idle' && stopRecording)  {
    stopRecording()
    stopRecording = null
    return
  }

  if (stopRecording) { return }
  if (!selectRecordCalls(ctx.getState())) { return }
  if (call.status !== 'connected' || !call.localStream || !call.remoteStream) { return }

  const date = new Date()
  const audioCtx = new AudioContext()
  const dest = audioCtx.createMediaStreamDestination()

  for (const stream of [call.remoteStream, call.localStream]) {
    audioCtx.createMediaStreamSource(stream).connect(dest)
  }

  const recorder = new RecordRTC(dest.stream, { type: 'audio' })
  recorder.startRecording()

  stopRecording = async function() {
    await new Promise<void>((resolve) => recorder.stopRecording(resolve))

    try {
      recorder.save(`recording ${dayjs(date).format('YY-MM-DD HH-mm-ss')}.webm`)
    } catch (e) {
      console.error(e)
    }

    recorder.destroy()
  }
})

export default all(
  recordCalls,
)
